import {
  FaJs,
  FaReact,
  FaNode,
  FaJava,
  FaPython,
  FaDatabase,
  FaAws,
  FaBootstrap,
  FaGithub,
  FaStripe
} from "react-icons/fa";
import {
  SiNextdotjs,
  SiThreedotjs,
  SiExpress,
  SiNestjs,
  SiTypescript,
  SiMysql,
  SiMongodb,
  SiPostgresql,
  SiSupabase,
  SiFirebase,
  SiVercel,
  SiNetlify,
  SiTailwindcss,
  SiJirasoftware,
  SiGoogleanalytics
} from "react-icons/si";

export const experiences = [
  {
    id: "robim",
    company: "RoBIM Technologies Inc.",
    role: "Full-Stack Developer",
    location: "Edmonton, Canada (Remote from Seoul, South Korea)",
    period: "Mar 2025 - Sep 2025",
    stack: "Next.js / TypeScript / Three.js / PostgreSQL / Vercel / AWS"
  },
  {
    id: "actibeety",
    company: "Actibeety",
    role: "Software Developer",
    location: "Vancouver, Canada (Remote from Calgary, Canada)",
    period: "Apr 2023 - Dec 2024",
    stack: "Next.js / TypeScript / Firebase / Vercel"
  }
];

export const projects = [
  {
    id: "cacart-ecommerce",
    title: "Cacart E-commerce Web Application (Team Project)",
    stack: "Next.js / TypeScript / Nest.js / TailwindCSS / Supabase / Stripe / Vercel",
    image: "./assets/cacart.png",
    github: "https://github.com/Snow-Penguins",
    live: "https://ca-cart-frontend.vercel.app"
  }, {
    id: "kimbap-ordering",
    title: "Online Kimbap Ordering Platform",
    stack: "React.js / Node.js / Express.js / Bootstrap / Firebase / Stripe / Netlify",
    image: "./assets/kimbap.png",
    github: "https://github.com/Eunji-Elly-Lee/Gimbap",
    live: "https://elly-kimbap.netlify.app"
  },
  {
    id: "restaurant-reviews",
    title: "Restaurant Reviews Web Application",
    stack: "React.js / Node.js / Express.js / Bootstrap / MongoDB",
    image: "./assets/restaurants.png",
    github: "https://github.com/Eunji-Elly-Lee/Restaurant-Reviews",
  },
  {
    id: "search-dataset",
    title: "City of Calgary Open Data Search",
    stack: "JavaScript / AJAX / JSON Parsing / Bootstrap/ Netlify",
    image: "./assets/searching.png",
    github: "https://github.com/Eunji-Elly-Lee/Search-Dataset",
    live: "https://elly-search-dataset.netlify.app"
  },
  {
    id: "medical-appointment",
    title: "Medical Clinic Appointment System (Team Project)",
    stack: "Java Servlet / JSP / JavaMail / MySQL",
    image: "./assets/medical.png",
    github: "https://github.com/Eunji-Elly-Lee/Medical-Appointment",
  },
  {
    id: "pang-game",
    title: "Pang Game with Python",
    stack: "Python / Pygame",
    image: "./assets/pang.png",
    github: "https://github.com/Eunji-Elly-Lee/Pang-In-Python",
  },
  {
    id: "hangman-game",
    title: "Hangman Game with GUI",
    stack: "Java / JavaFX",
    image: "./assets/hangman.png",
    github: "https://github.com/Eunji-Elly-Lee/Hangman-In-Java",
  }
];

export const skills = {
  frontend: [
    { icon: FaJs, title: "JavaScript" },
    { icon: SiTypescript, title: "Typescript" },
    { icon: FaReact, title: "React.js" },
    { icon: SiNextdotjs, title: "Next.js" },
    { icon: SiThreedotjs, title: "Three.js" },
    { icon: FaBootstrap, title: "Bootstrap" },
    { icon: SiTailwindcss, title: "Tailwind" }
  ],
  backend: [
    { icon: FaNode, title: "Node.js" },
    { icon: SiExpress, title: "Express.js" },
    { icon: SiNestjs, title: "Nest.js" },
    { icon: FaJava, title: "Java" },
    { icon: FaPython, title: "Python" },
    { icon: FaDatabase, title: "SQL" },
    { icon: SiMysql, title: "MySQL" },
    { icon: SiPostgresql, title: "PostgreSQL" },
    { icon: SiMongodb, title: "MongoDB" },
    { icon: SiFirebase, title: "Firebase" },
    { icon: SiSupabase, title: "Supabase" }
  ],
  tools: [
    { icon: SiVercel, title: "Vercel" },
    { icon: SiNetlify, title: "Netlify" },
    { icon: FaAws, title: "AWS" },
    { icon: FaStripe, title: "Stripe" },
    { icon: FaGithub, title: "GitHub" },
    { icon: SiJirasoftware, title: "Jira" },
    { icon: SiGoogleanalytics, title: "Google Analytics" }
  ]
};
